import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { DesignMode, getDesignTokens } from './designTokens';

export type TrustBarProps = {
  items: string[];
  mode?: DesignMode;
};

export const TrustBar = ({ items, mode = 'light' }: TrustBarProps) => {
  const tokens = getDesignTokens(mode);

  return (
    <Box
      role="list"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: `repeat(${items.length}, minmax(0, 1fr))`
        },
        overflow: 'hidden',
        border: `1px solid ${tokens.colors.border}`,
        borderRadius: tokens.radius.lg,
        background:
          mode === 'light'
            ? tokens.colors.surface
            : tokens.colors.surfaceRaised,
        boxShadow:
          mode === 'light'
            ? '0 18px 48px rgba(15,23,42,0.08)'
            : '0 20px 54px rgba(0,0,0,0.24)'
      }}
    >
      {items.map((label, index) => (
        <Box
          key={label}
          role="listitem"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.25,
            minWidth: 0,
            minHeight: { xs: 72, md: 88 },
            px: { xs: 2, md: 2.25 },
            py: { xs: 1.5, md: 2 },
            borderTop: {
              xs: index > 0 ? `1px solid ${tokens.colors.border}` : 'none',
              sm: index > 1 ? `1px solid ${tokens.colors.border}` : 'none',
              lg: 'none'
            },
            borderLeft: {
              xs: 'none',
              sm:
                index % 2 === 1 ? `1px solid ${tokens.colors.border}` : 'none',
              lg: index > 0 ? `1px solid ${tokens.colors.border}` : 'none'
            }
          }}
        >
          <Box
            sx={{
              width: 38,
              height: 38,
              flex: '0 0 38px',
              display: 'grid',
              placeItems: 'center',
              borderRadius: 1.5,
              border: `1px solid ${
                mode === 'light'
                  ? 'rgba(32,178,107,0.22)'
                  : 'rgba(103,232,165,0.24)'
              }`,
              background:
                mode === 'light'
                  ? 'rgba(32,178,107,0.1)'
                  : 'rgba(103,232,165,0.1)'
            }}
          >
            <CheckRoundedIcon
              sx={{ color: tokens.colors.green, fontSize: 23 }}
            />
          </Box>
          <Typography
            sx={{
              width: 'fit-content',
              maxWidth: 190,
              color: tokens.colors.text,
              fontSize: { xs: 14, md: 15 },
              fontWeight: 750,
              lineHeight: 1.3
            }}
          >
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
